(function (Drupal) {
    Drupal.behaviors.moveContainerData = {
      attach: function (context, settings) {
        // Función para mover el elemento container-data
        function moveContainerData() {
          // Seleccionar todos los elementos con la clase 'container-doctor'
          const containerDoctors = document.querySelectorAll('.container-doctor', context);
  
          containerDoctors.forEach(container => {
            const containerLeft = container.querySelector('.container-left');
            const containerRight = container.querySelector('.container-right');
            const containerData = containerLeft ? containerLeft.querySelector('.container-data') : null;
  
            if (containerLeft && containerRight && containerData) {
              // Mover el container-data al final de container-right
              containerRight.appendChild(containerData);
            }
          });
        }
  
        // Verificar si estamos en versión móvil
        function isMobile() {
          return window.innerWidth <= 768; // Ajusta este valor según tu breakpoint móvil
        }
  
        // Ejecutar la función si estamos en móvil
        if (isMobile()) {
          moveContainerData();
        }
  
        // Escuchar cambios en el tamaño de la ventana para actualizar la disposición en tiempo real
        window.addEventListener('resize', function () {
          if (isMobile()) {
            moveContainerData();
          }
        });
      }
    };
  })(Drupal);
  